export const OPEN_CUSTOMER_SERVICE_EVENT = 'dayu:open-kefu-dialog'

export interface CustomerServiceInfo {
  phone: string
  wechat: string
  workTime: string
  qrCodeUrl: string
}

function text(value: unknown): string {
  return typeof value === 'string' ? value.trim() : ''
}

export function normalizeCustomerServiceInfo(payload: unknown): CustomerServiceInfo {
  if (!payload || typeof payload !== 'object') {
    return { phone: '', wechat: '', workTime: '', qrCodeUrl: '' }
  }

  const source = payload as Record<string, unknown>
  return {
    phone: text(source.phone),
    wechat: text(source.wechat),
    workTime: text(source.work_time ?? source.workTime),
    qrCodeUrl: text(source.qrcode_url ?? source.qr_code ?? source.qrCodeUrl),
  }
}

export function hasCustomerServiceInfo(info: CustomerServiceInfo): boolean {
  return Boolean(info.phone || info.wechat || info.workTime || info.qrCodeUrl)
}

export function openCustomerServiceDialog(target: Pick<EventTarget, 'dispatchEvent'> = window): void {
  target.dispatchEvent(new Event(OPEN_CUSTOMER_SERVICE_EVENT))
}
